import React from 'react';
import { abrirArchivo, descargarArchivo, type BucketArchivos } from '../lib/archivos';

type Props = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href' | 'onClick' | 'target' | 'rel'> & {
  bucket: BucketArchivos;
  /** Valor guardado en la base: URL pública vieja o ruta en el bucket. */
  valor: string | null | undefined;
  /** Descarga en vez de abrir; si es texto, es el nombre del archivo descargado. */
  descargar?: string | boolean;
};

// Enlace a un archivo de un bucket privado: firma la URL en el clic (lib/archivos).
// Conserva la etiqueta <a> (y el resto de sus atributos) para no cambiar los
// estilos de cada pantalla.
export default function EnlaceArchivo({ bucket, valor, descargar, children, ...resto }: Props) {
  const onClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (descargar) void descargarArchivo(bucket, valor, typeof descargar === 'string' ? descargar : undefined);
    else void abrirArchivo(bucket, valor);
  };
  // Sin la URL real en href: con el bucket privado no abriría (ni con clic
  // central); el <a> se mantiene por los estilos de cada pantalla.
  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <a href="#" role="button" {...resto} onClick={onClick}>
      {children}
    </a>
  );
}
